import { ConfigurationType } from "@pages/Configurations/types";
import { BoatType, ReservationType, SettingType } from "src/types/types";
import { create } from "zustand";

const DEFAULT_CONFIG: string | undefined = import.meta.env.DEV
  ? import.meta.env.VITE_CONFIGURATION
  : ajaxCharter.configuration;

if (!DEFAULT_CONFIG) {
  throw Error("Missing AJAX_URL.");
}

type DataStore = {
  boats: BoatType[];
  setBoats: (boats: BoatType[]) => void;
  reservations: ReservationType[];
  setReservations: (reservations: ReservationType[]) => void;
  settings: SettingType[];
  setSettings: (reservations: SettingType[]) => void;
  configuration: ConfigurationType;
  setConfiguration: (configuration: ConfigurationType) => void;
};

const useDataStore = create<DataStore>((set) => ({
  boats: [],
  setBoats: (boats) => set({ boats }),
  reservations: [],
  setReservations: (reservations) => set({ reservations }),
  settings: [],
  setSettings: (settings) => set({ settings }),
  configuration: JSON.parse(DEFAULT_CONFIG),
  setConfiguration: (configuration) => set({ configuration }),
}));

export const boatSelector = (boatId: number) => (state: DataStore) =>
  state.boats.find((b) => b.id === boatId);

export const useBoat = (boatId: number) => useDataStore(boatSelector(boatId));

export const getBoat = (boatId: number) =>
  boatSelector(boatId)(useDataStore.getState());

export default useDataStore;
